import type { FC } from 'react';
import { Box, Grid2 } from '@mui/material';
import { NavResourceItem } from 'layouts/Main/constants';
import { NavLink } from './NavLink';

interface IProps {
  activeLink: string;
}

const ResourceNav: FC<IProps> = ({ activeLink }) => {
  return (
    <Box sx={{ minWidth: '300px' }}>
      <Grid2 container size={12}>
        <Grid2 size={12}>
          {NavResourceItem.map((sub) => (
            <NavLink activeLink={activeLink} url={sub.href} title={sub.label} />
          ))}
        </Grid2>
      </Grid2>
    </Box>
  );
};

export default ResourceNav;
